import dayjs, { PluginFunc } from "dayjs";

const plugin: PluginFunc<never> = (_, dayjsClass, __) => {
  dayjsClass.prototype.calendarFormat = function (sameElseFormat) {
    const today = dayjs();
    const targetDate = this;

    // Calculate differences
    const diffInDays = today.diff(targetDate, "day");
    const diffInWeeks = today.diff(targetDate, "week");

    let formatted: string;

    // Same day
    if (diffInDays === 0) {
      formatted = "Hoy";
    }
    // Yesterday
    else if (diffInDays === 1) {
      formatted = "Ayer";
    }
    // Tomorrow
    else if (diffInDays === -1) {
      formatted = "Mañana";
    }
    // Same week (within 7 days in the past)
    else if (diffInDays > 1 && diffInDays <= 6 && diffInWeeks === 0) {
      formatted = targetDate.format("dddd");
    }
    // Next week (within 7 days in the future)
    else if (diffInDays < -1 && diffInDays >= -6 && diffInWeeks === 0) {
      formatted = "Próxima semana";
    }
    // Last week (show day name)
    else if (diffInDays > 6 && diffInWeeks === 1) {
      formatted = targetDate.format("dddd");
    }
    // Everything else
    else {
      formatted = targetDate.format(sameElseFormat ?? "DD [de] MMM [de] YYYY");
    }

    if (!formatted || !formatted.charAt) {
      return "";
    }

    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };
};

declare module "dayjs" {
  interface Dayjs {
    calendarFormat(sameElseFormat?: string): string;
  }
}

export default plugin;
